module.exports = __webpack_public_path__ + "img/DK.57da7c02.svg";